module.exports = __webpack_public_path__ + "img/7.13eb6fe7.jpg";